<template>
  <graph-detail08-template
    :board-ids="[242]"
    field-code="facility"
    :com-group-list="comGroupList"
    graph1-title="전체 (시설물) 비상조치계획수립 현황"
    graph2-title="월별 (시설물) 비상조치계획수립 현황"
    graph3-title="기간별 (시설물) 비상조치계획수립 현황"
    field-category-label="시설물 구분"
    field-label="시설물"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail08Template from "@/views/graph-detail/GraphDetail08Template.vue";

export default {
  name: "GraphDetail61",
  components: {
    GraphDetail08Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
